import React, { useEffect, useState, Suspense } from 'react';
import { Localizer } from 'services/Localizer';
import { getUserData, UserData } from 'services/UserData';
import LockSimpleSVG from 'shared/components/svg/LockSimpleSVG';
import AccountUrls from 'shared/util/AccountUrls';
import { initReactApp } from 'shared/util/ApplicationInit';
import type PreHeader from 'features/pre-header/PreHeader';
import HeaderUtilNav from 'features/header/HeaderUtilNav';
const LazyPreHeader = React.lazy<typeof PreHeader>(
	() => import(/* webpackChunkName: "pre-header" */ 'features/pre-header/PreHeader'),
);

export const headerUtilsIconClass = 'roc-utlity-nav__menu-item-icon';

/**
 * Component that manages the logout in abrasive header utilities.
 *
 * @export
 * @returns
 */
export default function AbrasiveHeaderUtils() {
	const [userData, setUserData] = useState<UserData | null>(null);

	useEffect(() => {
		(async () => {
			try {
				const data = (await getUserData()).data;

				setUserData(data);

				if (data.impersonation != null) {
					initReactApp(
						() => (
							<Suspense fallback={<div>Loading Impersonation Controls...</div>}>
								<LazyPreHeader />
							</Suspense>
						),
						'roc-pre-header',
					)();
				}
				// #endregion
			} catch (error) {
				console.error('Unable to load user data.', error);
			}
		})();
	}, []);

	if (!userData) {
		return null;
	}

	const iconClass = 'roc-utlity-nav__menu-item-link-icon';

	return (
		<HeaderUtilNav>
			{userData && userData.summary && userData.summary.isSignedIn ? (
				<>
					<li className="roc-utlity-nav__menu-item">
						<form action={`${AccountUrls.Logout}?returnUrl=%2F`} method="post" id="logoutForm">
							<button
								type="submit"
								className="roc-utlity-nav__menu-item-link"
								data-testid="my-account-popover-logout-link"
							>
								<LockSimpleSVG className={iconClass} />
								{Localizer('HeaderUtilNavLogout')}
							</button>
						</form>
					</li>
				</>
			) : null}
		</HeaderUtilNav>
	);
}
